module.exports = __webpack_public_path__ + "static/img/collect-blue.5c037ff8.png";